export const step2ChpList = {
  // # Cardiovascular topics
  cardiovascular: [
    {
      id: "anatomy",
      name: "Anatomy",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_ANATOMY,
    },
    {
      id: "heart_sounds_jvp",
      name: "Heart Sounds & JVP",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_HEART_SOUNDS_JVP,
    },
    {
      id: "heart_failure",
      name: "Heart Failure",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_HEART_FAILURE,
    },
    {
      id: "cardiomyopathy",
      name: "Cardiomyopathy",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_CARDIOMYOPATHY,
    },
    {
      id: "pericardial_disease",
      name: "Pericardial Disease",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_PERICARDIAL_DISEASE,
    },
    {
      id: "cardiac_vascular_malignancy",
      name: "Cardiac & Vascular Malignancy",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_CARDIAC_VASCULAR_MALIGNANCY,
    },
    {
      id: "valvular_heart_disease",
      name: "Valvular Heart Disease",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_VALVULAR_HEART_DISEASE,
    },
    {
      id: "coronary_artery_disease",
      name: "Coronary Artery Disease",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_CORONARY_ARTERY_DISEASE,
    },
    {
      id: "inflammatory_cardiac_disease",
      name: "Inflammatory Cardiac Disease",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_INFLAMMATORY_CARDIAC_DISEASE,
    },
    {
      id: "arrhythmias_basics_of_ecg",
      name: "Basics of ECG",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_ARRHYTHMIAS_BASICS_OF_ECG,
    },
    {
      id: "arrhythmias_introduction_to_tachyarrhythmias",
      name: "Introduction to Tachyarrhythmias",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_ARRHYTHMIAS_INTRODUCTION_TO_TACHYARRHYTHMIAS,
    },
    {
      id: "arrhythmias_supraventricular_tachyarrhythmias",
      name: "Supraventricular Tachyarrhythmias",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_ARRHYTHMIAS_SUPRAVENTRICULAR_TACHYARRHYTHMIAS,
    },
    {
      id: "arrhythmias_ventricular_arrhythmias_and_acls",
      name: "Ventricular Arrhythmias & ACLS",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_ARRHYTHMIAS_VENTRICULAR_ARRHYTHMIAS_AND_ACLS,
    },
    {
      id: "arrhythmias_bradyarrhythmias",
      name: "Bradyarrhythmias",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_ARRHYTHMIAS_BRADYARRHYTHMIAS,
    },
    {
      id: "arrhythmias_cardiac_implantable_devices",
      name: "Cardiac Implantable Devices",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_ARRHYTHMIAS_CARDIAC_IMPLANTABLE_DEVICES,
    },
    {
      id: "arrhythmias_review",
      name: "Review on Arrhythmias",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_ARRHYTHMIAS_REVIEW,
    },
    {
      id: "syncope",
      name: "Syncope",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_SYNCOPE,
    },
    {
      id: "hyperlipidemia",
      name: "Hyperlipidemia",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_HYPERLIPIDEMIA,
    },
    {
      id: "hypertension",
      name: "Hypertension",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_HYPERTENSION,
    },
    {
      id: "congenital_defects_introduction_and_overview",
      name: "Congenital Heart Defects",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_CONGENITAL_DEFECTS_INTRODUCTION_AND_OVERVIEW,
    },
    {
      id: "congenital_defects_acyanotic_defects",
      name: "Acyanotic Defects",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_CONGENITAL_DEFECTS_ACYANOTIC_DEFECTS,
    },
    {
      id: "congenital_defects_cyanotic_defects",
      name: "Cyanotic Defects",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_CONGENITAL_DEFECTS_CYANOTIC_DEFECTS,
    },
    {
      id: "congenital_defects_misc_defects",
      name: "Misc Defects",
      url: process.env
        .REACT_APP_STEP2_CARDIOVASCULAR_CONGENITAL_DEFECTS_MISC_DEFECTS,
    },
    {
      id: "vascular_disease",
      name: "Vascular Disease",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_VASCULAR_DISEASE,
    },
    {
      id: "cardiothoracic_surgery",
      name: "Cardiothoracic Surgery",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_CARDIOTHORACIC_SURGERY,
    },
    {
      id: "chest_pain",
      name: "Chest Pain",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_CHEST_PAIN,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_PHARMACOLOGY,
    },
    {
      id: "cardiology_cases",
      name: "Cardiology Cases",
      url: process.env.REACT_APP_STEP2_CARDIOVASCULAR_CARDIOLOGY_CASES,
    },
  ],

  // # Respiratory and ENT topics
  respiratory_and_ent: [
    {
      id: "chest_anatomy",
      name: "Chest Anatomy",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_CHEST_ANATOMY,
    },
    {
      id: "physical_exam_pfts",
      name: "Physical Exam/PFTs",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_PHYSICAL_EXAM_PFTS,
    },
    {
      id: "obstructive_lung_disease",
      name: "Obstructive Lung Disease",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_OBSTRUCTIVE_LUNG_DISEASE,
    },
    {
      id: "restrictive_lung_disease",
      name: "Restrictive Lung Disease",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_RESTRICTIVE_LUNG_DISEASE,
    },
    {
      id: "sleep_apneas_hypoventilation",
      name: "Sleep Apneas & Hypoventilation",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_SLEEP_APNEAS_HYPOVENTILATION,
    },
    {
      id: "pulmonary_hypertension",
      name: "Pulmonary Hypertension",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_PULMONARY_HYPERTENSION,
    },
    {
      id: "dyspnea",
      name: "Dyspnea",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_DYSPNEA,
    },
    {
      id: "hypoxemia",
      name: "Hypoxemia",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_HYPOXEMIA,
    },
    {
      id: "respiratory_failure",
      name: "Respiratory Failure",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_RESPIRATORY_FAILURE,
    },
    {
      id: "shock_sepsis",
      name: "Shock/Sepsis",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_SHOCK_SEPSIS,
    },
    {
      id: "malignancy_lung_cancer",
      name: "Lung Cancer",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_MALIGNANCY_LUNG_CANCER,
    },
    {
      id: "malignancy_lung_nodules",
      name: "Lung Nodules",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_MALIGNANCY_LUNG_NODULES,
    },
    {
      id: "malignancy_mediastinal_mass_and_mesothelioma",
      name: "Mediastinal Mass & Mesothelioma",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_MALIGNANCY_MEDIASTINAL_MASS_AND_MESOTHELIOMA,
    },
    {
      id: "pleural_diseases",
      name: "Pleural Diseases",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_PLEURAL_DISEASES,
    },
    {
      id: "pneumothorax_hemoptysis_cough",
      name: "Pneumothorax, Hemoptysis & Cough",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_PNEUMOTHORAX_HEMOPTYSIS_COUGH,
    },
    {
      id: "embolism",
      name: "Embolism",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_EMBOLISM,
    },
    {
      id: "tract_infection_pneumonia_lung_abscess_aspiration",
      name: "Pneumonia / Lung Abscess / Aspiration",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_TRACT_INFECTION_PNEUMONIA_LUNG_ABSCESS_ASPIRATION,
    },
    {
      id: "tract_infection_tuberculosis",
      name: "Tuberculosis",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_TRACT_INFECTION_TUBERCULOSIS,
    },
    {
      id: "tract_infection_urti",
      name: "URTI",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_TRACT_INFECTION_URTI,
    },
    {
      id: "pediatric_respiratory_infections",
      name: "Pediatric Respiratory Infections",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_PEDIATRIC_RESPIRATORY_INFECTIONS,
    },
    {
      id: "miscellaneous_pediatric_diseases",
      name: "Miscellaneous Pediatric Diseases",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_MISCELLANEOUS_PEDIATRIC_DISEASES,
    },
    {
      id: "allergy",
      name: "Allergy",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_ALLERGY,
    },
    {
      id: "ent_oral_lesions",
      name: "Oral Lesions",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_ENT_ORAL_LESIONS,
    },
    {
      id: "ent_nasal_pathology",
      name: "Nasal Pathology",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_ENT_NASAL_PATHOLOGY,
    },
    {
      id: "ent_deep_neck_infections",
      name: "Deep Neck Infections",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_ENT_DEEP_NECK_INFECTIONS,
    },
    {
      id: "ent_head_and_neck_disorders",
      name: "Head and Neck Disorders",
      url: process.env
        .REACT_APP_STEP2_RESPIRATORY_AND_ENT_ENT_HEAD_AND_NECK_DISORDERS,
    },
    {
      id: "ear",
      name: "Ear",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_EAR,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_PHARMACOLOGY,
    },
    {
      id: "chest_trauma",
      name: "Chest Trauma",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_CHEST_TRAUMA,
    },
    {
      id: "ent_cases",
      name: "Respiratory & ENT Cases",
      url: process.env.REACT_APP_STEP2_RESPIRATORY_AND_ENT_CASES,
    },
  ],

  // # Renal and Urology topics
  renal_and_urology: [
    {
      id: "anatomy",
      name: "Anatomy",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_ANATOMY,
    },
    {
      id: "volume",
      name: "Volume",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_VOLUME,
    },
    {
      id: "electrolytes",
      name: "Electrolytes",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_ELECTROLYTES,
    },
    {
      id: "acid_base",
      name: "Acid Base",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_ACID_BASE,
    },
    {
      id: "failure",
      name: "Renal Failure",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_FAILURE,
    },
    {
      id: "glomerular_pathology",
      name: "Glomerular Pathology",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_GLOMERULAR_PATHOLOGY,
    },
    {
      id: "tubulointerstitial_disease",
      name: "Tubulointerstitial Disease",
      url: process.env
        .REACT_APP_STEP2_RENAL_AND_UROLOGY_TUBULOINTERSTITIAL_DISEASE,
    },
    {
      id: "vascular_disease",
      name: "Renal Vascular Disease",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_VASCULAR_DISEASE,
    },
    {
      id: "cystic_kidney_disease",
      name: "Cystic Kidney Disease",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_CYSTIC_KIDNEY_DISEASE,
    },
    {
      id: "nephrolithiasis",
      name: "Nephrolithiasis",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_NEPHROLITHIASIS,
    },
    {
      id: "incontinence_retention",
      name: "Incontinence & Retention",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_INCONTINENCE_RETENTION,
    },
    {
      id: "urinary_tract_infections",
      name: "Urinary Tract Infections",
      url: process.env
        .REACT_APP_STEP2_RENAL_AND_UROLOGY_URINARY_TRACT_INFECTIONS,
    },
    {
      id: "malignancy",
      name: "Malignancy",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_MALIGNANCY,
    },
    {
      id: "pediatric",
      name: "Pediatric Urology/Renal",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_PEDIATRIC,
    },
    {
      id: "testicular_tumors",
      name: "Testicular Tumors",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_TESTICULAR_TUMORS,
    },
    {
      id: "prostate_disorders",
      name: "Prostate Disorders",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_PROSTATE_DISORDERS,
    },
    {
      id: "penile_pathology",
      name: "Penile/Testicular/Scrotal Pathology",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_PENILE_PATHOLOGY,
    },
    {
      id: "proteinuria_hematuria",
      name: "Proteinuria & Hematuria",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_PROTEINURIA_HEMATURIA,
    },
    {
      id: "genitourinary_trauma",
      name: "Genito-urinary Trauma",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_GENITOURINARY_TRAUMA,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_PHARMACOLOGY,
    },
    {
      id: "cases",
      name: "Renal & Urology Cases",
      url: process.env.REACT_APP_STEP2_RENAL_AND_UROLOGY_CASES,
    },
  ],

  // # Endocrine topics
  endocrine: [
    {
      id: "thyroid_disease",
      name: "Thyroid Disease",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_THYROID_DISEASE,
    },
    {
      id: "polyuria",
      name: "Polyuria",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_POLYURIA,
    },
    {
      id: "cortisol_aldosterone",
      name: "Cortisol and Aldosterone",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_CORTISOL_ALDOSTERONE,
    },
    {
      id: "pituitary_disorders",
      name: "Pituitary Disorders",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_PITUITARY_DISORDERS,
    },
    {
      id: "parathyroid_disorders",
      name: "Parathyroid Disorders",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_PARATHYROID_DISORDERS,
    },
    {
      id: "male_reproductive",
      name: "Male Reproductive Endocrinology",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_MALE_REPRODUCTIVE,
    },
    {
      id: "adrenal_neoplasia",
      name: "Adrenal Neoplasia",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_ADRENAL_NEOPLASIA,
    },
    {
      id: "neuroendocrine_tumors",
      name: "Neuroendocrine Tumors",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_NEUROENDOCRINE_TUMORS,
    },
    {
      id: "hypoglycemia_diabetes",
      name: "Hypoglycemia & Diabetes Mellitus",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_HYPOGLYCEMIA_DIABETES,
    },
    {
      id: "pediatric",
      name: "Pediatric Endocrine",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_PEDIATRIC,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_PHARMACOLOGY,
    },
    {
      id: "cases",
      name: "Endocrine Cases",
      url: process.env.REACT_APP_STEP2_ENDOCRINE_CASES,
    },
  ],

  // # Hematology and Oncology topics
  hematology_and_oncology: [
    {
      id: "anemia_overview",
      name: "Anemia Overview",
      url: process.env.REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_ANEMIA_OVERVIEW,
    },
    {
      id: "microcytic_anemia",
      name: "Microcytic Anemia",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_MICROCYTIC_ANEMIA,
    },
    {
      id: "macrocytic_anemia",
      name: "Macrocytic Anemia",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_MACROCYTIC_ANEMIA,
    },
    {
      id: "normocytic_anemia",
      name: "Normocytic Anemia",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_NORMOCYTIC_ANEMIA,
    },
    {
      id: "heme_synthesis",
      name: "Disorders of Heme Synthesis",
      url: process.env.REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_HEME_SYNTHESIS,
    },
    {
      id: "platelet_disorders",
      name: "Platelet Disorders",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_PLATELET_DISORDERS,
    },
    {
      id: "coagulation_disorders",
      name: "Coagulation Disorders",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_COAGULATION_DISORDERS,
    },
    {
      id: "pharmacology",
      name: "Hematology Pharmacology",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_BLOOD_PHARMACOLOGY,
    },
    {
      id: "leukemia",
      name: "Leukemia",
      url: process.env.REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_LEUKEMIA,
    },
    {
      id: "leukopenia",
      name: "Leukopenia",
      url: process.env.REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_LEUKOPENIA,
    },
    {
      id: "lymphoma",
      name: "Lymphoma",
      url: process.env.REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_LYMPHOMA,
    },
    {
      id: "myeloproliferative",
      name: "Myeloproliferative Disease",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_MYELOPROLIFERATIVE,
    },
    {
      id: "plasma_cell_dyscrasias",
      name: "Plasma Cell Dyscrasias",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_PLASMA_CELL_DYSCRASIAS,
    },
    {
      id: "other_malignancies",
      name: "Other Hematologic Malignancies",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_OTHER_MALIGNANCIES,
    },
    {
      id: "oncological_emergencies",
      name: "Oncological Therapies & Emergencies",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_ONCOLOGICAL_EMERGENCIES,
    },
    {
      id: "cancer_pharmacology",
      name: "Oncology Pharmacology",
      url: process.env
        .REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_CANCER_PHARMACOLOGY,
    },
    {
      id: "cases",
      name: "Hematology, Oncology, & Immunology Cases",
      url: process.env.REACT_APP_STEP2_HEMATOLOGY_AND_ONCOLOGY_CASES,
    },
  ],

  // # Immunology topics
  immunology: [
    {
      id: "primary_immunodeficiencies",
      name: "Primary Immunodeficiencies",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_PRIMARY_IMMUNODEFICIENCIES,
    },
    {
      id: "transfusions",
      name: "Transfusions",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_TRANSFUSIONS,
    },
    {
      id: "transplant",
      name: "Transplant",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_TRANSPLANT,
    },
    {
      id: "reactions",
      name: "Immunologic Reactions",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_REACTIONS,
    },
    {
      id: "amyloidosis",
      name: "Amyloidosis",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_AMYLOIDOSIS,
    },
    {
      id: "immunosuppressants",
      name: "Immunosuppressants",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_IMMUNOSUPPRESSANTS,
    },
    {
      id: "autoantibodies_hla",
      name: "Auto-antibodies & HLAs",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_AUTOANTIBODIES_HLA,
    },
    {
      id: "cases",
      name: "Immunology Cases",
      url: process.env.REACT_APP_STEP2_IMMUNOLOGY_CASES,
    },
  ],

  // # Empty arrays for chapters without URLs yet
  gastrointestinal: [
    {
      id: "esophageal_disease",
      name: "Esophageal Disease",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_ESOPHAGEAL_DISEASE,
    },
    {
      id: "gastric_disease",
      name: "Gastric Disease",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_GASTRIC_DISEASE,
    },
    {
      id: "intestinal_disease",
      name: "Intestinal Disease",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_INTESTINAL_DISEASE,
    },
    {
      id: "hepatobiliary_disease_cirrhosis_and_liver_failure",
      name: "Cirrhosis & Liver Failure",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_CIRRHOSIS_AND_LIVER_FAILURE,
    },
    {
      id: "hepatobiliary_disease_liver_masses",
      name: "Liver Masses",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_LIVER_MASSES,
    },
    {
      id: "hepatobiliary_disease_viral_hepatitis",
      name: "Viral Hepatitis",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_VIRAL_HEPATITIS,
    },
    {
      id: "hepatobiliary_disease_misc_liver_disease",
      name: "Misc Liver Disease",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_MISC_LIVER_DISEASE,
    },
    {
      id: "hepatobiliary_disease_interpretation_of_lfts",
      name: "Interpretation of LFTs",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_INTERPRETATION_OF_LFTS,
    },
    {
      id: "hepatobiliary_disease_biliary_pathology",
      name: "Biliary Pathology",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_BILIARY_PATHOLOGY,
    },
    {
      id: "hepatobiliary_disease_pancreatic_pathology",
      name: "Pancreatic Pathology",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_PANCREATIC_PATHOLOGY,
    },
    {
      id: "hepatobiliary_disease_splenic_pathology",
      name: "Splenic Pathology",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_HEPATOBILIARY_DISEASE_SPLENIC_PATHOLOGY,
    },
    {
      id: "anal_disease",
      name: "Anal Disease",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_ANAL_DISEASE,
    },
    {
      id: "gi_bleeding",
      name: "GI Bleeding",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_GI_BLEEDING,
    },
    {
      id: "diarrhea_constipation_vomiting",
      name: "Diarrhea, Constipation & Vomiting",
      url: process.env
        .REACT_APP_STEP2_GASTROINTESTINAL_DIARRHEA_CONSTIPATION_VOMITING,
    },
    {
      id: "pediatric_disorders",
      name: "Pediatric GI Disorders",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_PEDIATRIC_DISORDERS,
    },
    {
      id: "nutrition",
      name: "Nutrition",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_NUTRITION,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_PHARMACOLOGY,
    },
    {
      id: "abdominal_trauma",
      name: "Abdominal Trauma",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_ABDOMINAL_TRAUMA,
    },
    {
      id: "miscellaneous",
      name: "Miscellaneous",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_MISCELLANEOUS,
    },
    {
      id: "infections",
      name: "GI Infections",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_INFECTIONS,
    },
    {
      id: "cases",
      name: "GI Cases",
      url: process.env.REACT_APP_STEP2_GASTROINTESTINAL_CASES,
    },
  ],
  musculoskeletal: [
    {
      id: "general_orthopedics",
      name: "General Orthopedics",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_GENERAL_ORTHOPEDICS,
    },
    {
      id: "pediatric_orthopedic",
      name: "Pediatric Orthopedic",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_PEDIATRIC_ORTHOPEDIC,
    },
    {
      id: "bones",
      name: "Bones",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_BONES,
    },
    {
      id: "joints_osteoarthritis_and_rheumatoid_arthritis_and_juvenile_ia",
      name: "Osteoarthritis & Rheumatoid Arthritis & Juvenile IA",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_JOINTS_OSTEOARTHRITIS_AND_RHEUMATOID_ARTHRITIS_AND_JUVENILE_IA,
    },
    {
      id: "joints_gout_and_cppd",
      name: "Gout & CPPD",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_JOINTS_GOUT_AND_CPPD,
    },
    {
      id: "joints_seronegative_arthritis_and_infections",
      name: "Seronegative Arthritis & Infections",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_JOINTS_SERONEGATIVE_ARTHRITIS_AND_INFECTIONS,
    },
    {
      id: "joints_misc_arthritis_and_bursitis",
      name: "Misc Arthritis & Bursitis",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_JOINTS_MISC_ARTHRITIS_AND_BURSITIS,
    },
    {
      id: "myopathy",
      name: "Myopathy",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_MYOPATHY,
    },
    {
      id: "autoimmunity",
      name: "Autoimmunity",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_AUTOIMMUNITY,
    },
    {
      id: "vasculitis",
      name: "Vasculitis",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_VASCULITIS,
    },
    {
      id: "bone_soft_tissue_malignancy",
      name: "Bone & Soft Tissue Malignancy",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_BONE_SOFT_TISSUE_MALIGNANCY,
    },
    {
      id: "peripheral_nerve_lesions_brachial_plexus_lesions",
      name: "Brachial Plexus Lesions",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_PERIPHERAL_NERVE_LESIONS_BRACHIAL_PLEXUS_LESIONS,
    },
    {
      id: "peripheral_nerve_lesions_upper_extremity_nerve_lesions",
      name: "Upper Extremity Nerve Lesions",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_PERIPHERAL_NERVE_LESIONS_UPPER_EXTREMITY_NERVE_LESIONS,
    },
    {
      id: "peripheral_nerve_lesions_lower_extremity_nerve_lesions",
      name: "Lower Extremity Nerve Lesions",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_PERIPHERAL_NERVE_LESIONS_LOWER_EXTREMITY_NERVE_LESIONS,
    },
    {
      id: "back_and_neck_overview_of_low_back_pain",
      name: "Overview of Low Back Pain",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_BACK_AND_NECK_OVERVIEW_OF_LOW_BACK_PAIN,
    },
    {
      id: "back_and_neck_degenerative_back_pain",
      name: "Degenerative Back Pain",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_BACK_AND_NECK_DEGENERATIVE_BACK_PAIN,
    },
    {
      id: "back_and_neck_infectious_back_pain",
      name: "Infectious Back Pain",
      url: process.env
        .REACT_APP_STEP2_MUSCULOSKELETAL_BACK_AND_NECK_INFECTIOUS_BACK_PAIN,
    },
    {
      id: "shoulder",
      name: "Shoulder",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_SHOULDER,
    },
    {
      id: "arm_elbow_forearm",
      name: "Arm, Elbow & Forearm",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_ARM_ELBOW_FOREARM,
    },
    {
      id: "hand",
      name: "Hand",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_HAND,
    },
    {
      id: "hip_thigh",
      name: "Hip & Thigh",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_HIP_THIGH,
    },
    {
      id: "knee",
      name: "Knee",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_KNEE,
    },
    {
      id: "leg_foot",
      name: "Leg & Foot",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_LEG_FOOT,
    },

    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_PHARMACOLOGY,
    },
    {
      id: "cases",
      name: "MSK Cases",
      url: process.env.REACT_APP_STEP2_MUSCULOSKELETAL_CASES,
    },
  ],
  neurology: [
    {
      id: "stroke",
      name: "Stroke",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_STROKE,
    },
    {
      id: "cranial_bleeding",
      name: "Cranial Bleeding",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_CRANIAL_BLEEDING,
    },
    {
      id: "intracranial_hypertension",
      name: "Intracranial Hypertension",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_INTRACRANIAL_HYPERTENSION,
    },
    {
      id: "traumatic_brain_injury",
      name: "Traumatic Brain Injury",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_TRAUMATIC_BRAIN_INJURY,
    },
    {
      id: "movement_disorders",
      name: "Movement Disorders",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_MOVEMENT_DISORDERS,
    },
    {
      id: "gait_cerebellar_disorders",
      name: "Gait & Cerebellar Disorders",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_GAIT_CEREBELLAR_DISORDERS,
    },
    {
      id: "demyelinating_disease",
      name: "Demyelinating Disease",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_DEMYELINATING_DISEASE,
    },
    {
      id: "spine_spinal_cord_lesions",
      name: "Spine & Spinal Cord Lesions",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_SPINE_SPINAL_CORD_LESIONS,
    },
    {
      id: "neuromuscular_diseases",
      name: "Neuromuscular Diseases",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_NEUROMUSCULAR_DISEASES,
    },
    {
      id: "hydrocephalus",
      name: "Hydrocephalus",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_HYDROCEPHALUS,
    },
    {
      id: "dementia",
      name: "Dementia",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_DEMENTIA,
    },
    {
      id: "altered_mental_status",
      name: "Altered Mental Status",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_ALTERED_MENTAL_STATUS,
    },
    {
      id: "headache",
      name: "Headache",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_HEADACHE,
    },
    {
      id: "vertigo",
      name: "Vertigo",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_VERTIGO,
    },
    {
      id: "seizures",
      name: "Seizures",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_SEIZURES,
    },
    {
      id: "neuropathy_neuropathic_pain",
      name: "Neuropathy & Neuropathic Pain",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_NEUROPATHY_NEUROPATHIC_PAIN,
    },
    {
      id: "cns_infections",
      name: "CNS Infections",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_CNS_INFECTIONS,
    },
    {
      id: "cns_tumors",
      name: "CNS Tumors",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_CNS_TUMORS,
    },
    {
      id: "neurocutaneous_disorders",
      name: "Neurocutaneous Disorders",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_NEUROCUTANEOUS_DISORDERS,
    },
    {
      id: "congenital_neurological_disease",
      name: "Congenital Neurological Disease",
      url: process.env
        .REACT_APP_STEP2_NEUROLOGY_CONGENITAL_NEUROLOGICAL_DISEASE,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_PHARMACOLOGY,
    },
    {
      id: "cases",
      name: "Neurology Cases",
      url: process.env.REACT_APP_STEP2_NEUROLOGY_CASES,
    },
  ],
  ophthalmology: [
    {
      id: "eyelid_pathology",
      name: "Eyelid Pathology",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_EYELID_PATHOLOGY,
    },
    {
      id: "conjunctival_disorders",
      name: "Conjunctival Disorders",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_CONJUNCTIVAL_DISORDERS,
    },
    {
      id: "scleral_disorders",
      name: "Scleral Disorders",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_SCLERAL_DISORDERS,
    },
    {
      id: "lens_disorders",
      name: "Lens Disorders",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_LENS_DISORDERS,
    },
    {
      id: "corneal_disorders",
      name: "Corneal Disorders",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_CORNEAL_DISORDERS,
    },
    {
      id: "glaucoma",
      name: "Glaucoma",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_GLAUCOMA,
    },
    {
      id: "sudden_visual_loss",
      name: "Sudden Visual Loss",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_SUDDEN_VISUAL_LOSS,
    },
    {
      id: "retinal_disorders",
      name: "Retinal Disorders",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_RETINAL_DISORDERS,
    },
    {
      id: "eye_infections_and_inflammation",
      name: "Eye Infections & Inflammation",
      url: process.env
        .REACT_APP_STEP2_OPHTHALMOLOGY_EYE_INFECTIONS_AND_INFLAMMATION,
    },
    {
      id: "eye_movement_visual_field_and_pupil",
      name: "Eye Movement, Visual Field & Pupil",
      url: process.env
        .REACT_APP_STEP2_OPHTHALMOLOGY_EYE_MOVEMENT_VISUAL_FIELD_AND_PUPIL,
    },
    {
      id: "ocular_trauma",
      name: "Ocular Trauma",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_OCULAR_TRAUMA,
    },
    {
      id: "pediatric_eye_disorders",
      name: "Pediatric Eye Disorders",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_PEDIATRIC_EYE_DISORDERS,
    },
    {
      id: "miscellaneous",
      name: "Miscellaneous Eye Disorders",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_MISCELLANEOUS,
    },
    {
      id: "cases",
      name: "Ophthalmology Cases",
      url: process.env.REACT_APP_STEP2_OPHTHALMOLOGY_CASES,
    },
  ],
  psychiatry: [
    {
      id: "psychiatry_basics",
      name: "Psychiatry Basics",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_PSYCHIATRY_BASICS,
    },
    {
      id: "delirium",
      name: "Delirium",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_DELIRIUM,
    },
    {
      id: "psychotic_disorders",
      name: "Psychotic Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_PSYCHOTIC_DISORDERS,
    },
    {
      id: "mood_disorders",
      name: "Mood Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_MOOD_DISORDERS,
    },
    {
      id: "anxiety_disorders",
      name: "Anxiety Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_ANXIETY_DISORDERS,
    },
    {
      id: "personality_disorders",
      name: "Personality Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_PERSONALITY_DISORDERS,
    },
    {
      id: "somatic_disorders",
      name: "Somatic Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_SOMATIC_DISORDERS,
    },
    {
      id: "amnesia_and_dissociative_disorders",
      name: "Amnesia & Dissociative Disorders",
      url: process.env
        .REACT_APP_STEP2_PSYCHIATRY_AMNESIA_AND_DISSOCIATIVE_DISORDERS,
    },
    {
      id: "eating_disorders",
      name: "Eating Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_EATING_DISORDERS,
    },
    {
      id: "sex_and_gender_disorders",
      name: "Sex & Gender Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_SEX_AND_GENDER_DISORDERS,
    },
    {
      id: "sleep_disorders",
      name: "Sleep Disorders",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_SLEEP_DISORDERS,
    },
    {
      id: "child_psychiatry",
      name: "Child Psychiatry",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_CHILD_PSYCHIATRY,
    },
    {
      id: "substance_use",
      name: "Substance Use",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_SUBSTANCE_USE,
    },
    {
      id: "psychotherapy",
      name: "Psychotherapy",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_PSYCHOTHERAPY,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_PHARMACOLOGY,
    },
    {
      id: "cases",
      name: "Psychiatry Cases",
      url: process.env.REACT_APP_STEP2_PSYCHIATRY_CASES,
    },
  ],
  dermatology: [
    {
      id: "dermatology_basics",
      name: "Dermatology Basics",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_DERMATOLOGY_BASICS,
    },
    {
      id: "benign_miscellaneous_disorders",
      name: "Benign & Miscellaneous Disorders",
      url: process.env
        .REACT_APP_STEP2_DERMATOLOGY_BENIGN_MISCELLANEOUS_DISORDERS,
    },
    {
      id: "inflammatory_disorders",
      name: "Inflammatory Disorders",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_INFLAMMATORY_DISORDERS,
    },
    {
      id: "blistering_disorders",
      name: "Blistering Disorders",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_BLISTERING_DISORDERS,
    },
    {
      id: "sun_related_skin_disorders",
      name: "Sun-Related Skin Disorders",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_SUN_RELATED_SKIN_DISORDERS,
    },
    {
      id: "viral_skin_infections",
      name: "Viral Skin Infections",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_VIRAL_SKIN_INFECTIONS,
    },
    {
      id: "fungal_skin_infections",
      name: "Fungal Skin Infections",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_FUNGAL_SKIN_INFECTIONS,
    },
    {
      id: "parasitic_skin_infections",
      name: "Parasitic Skin Infections",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_PARASITIC_SKIN_INFECTIONS,
    },
    {
      id: "bacterial_skin_infections",
      name: "Bacterial Skin Infections",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_BACTERIAL_SKIN_INFECTIONS,
    },
    {
      id: "soft_tissue_ulcers",
      name: "Soft Tissue Ulcers",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_SOFT_TISSUE_ULCERS,
    },
    {
      id: "hair_and_nail_disorders",
      name: "Hair & Nail Disorders",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_HAIR_AND_NAIL_DISORDERS,
    },
    {
      id: "vascular_skin_tumors",
      name: "Vascular Skin Tumors",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_VASCULAR_SKIN_TUMORS,
    },
    {
      id: "dermatologic_malignancy",
      name: "Dermatologic Malignancy",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_DERMATOLOGIC_MALIGNANCY,
    },
    {
      id: "cases",
      name: "Dermatology Cases",
      url: process.env.REACT_APP_STEP2_DERMATOLOGY_CASES,
    },
  ],
  gynecology: [
    {
      id: "menstrual_cycle_and_related_disorders",
      name: "Menstrual Cycle & Related Disorders",
      url: process.env
        .REACT_APP_STEP2_GYNECOLOGY_MENSTRUAL_CYCLE_AND_RELATED_DISORDERS,
    },
    {
      id: "contraception",
      name: "Contraception",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_CONTRACEPTION,
    },
    {
      id: "infertility",
      name: "Infertility",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_INFERTILITY,
    },
    {
      id: "hyperandrogenism",
      name: "Hyperandrogenism",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_HYPERANDROGENISM,
    },
    {
      id: "abnormal_uterine_bleeding",
      name: "Abnormal Uterine Bleeding",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_ABNORMAL_UTERINE_BLEEDING,
    },
    {
      id: "pelvic_pain_in_women",
      name: "Pelvic Pain in Women",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_PELVIC_PAIN_IN_WOMEN,
    },
    {
      id: "organ_prolapse",
      name: "Organ Prolapse",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_ORGAN_PROLAPSE,
    },
    {
      id: "amenorrhea",
      name: "Amenorrhea",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_AMENORRHEA,
    },
    {
      id: "ovary",
      name: "Ovary",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_OVARY,
    },
    {
      id: "uterus",
      name: "Uterus",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_UTERUS,
    },
    {
      id: "cervix",
      name: "Cervix",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_CERVIX,
    },
    {
      id: "vulva_and_vagina",
      name: "Vulva & Vagina",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_VULVA_AND_VAGINA,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_PHARMACOLOGY,
    },
    {
      id: "cases",
      name: "Gynecology Cases",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_CASES,
    },
    {
      id: "evaluation_of_nipple_discharge",
      name: "Evaluation of Nipple Discharge",
      url: process.env
        .REACT_APP_STEP2_GYNECOLOGY_EVALUATION_OF_NIPPLE_DISCHARGE,
    },
    {
      id: "evaluation_of_new_breast_mass",
      name: "Evaluation of New Breast Mass",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_EVALUATION_OF_NEW_BREAST_MASS,
    },
    {
      id: "evaluation_of_mastalgia",
      name: "Evaluation of Mastalgia",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_EVALUATION_OF_MASTALGIA,
    },
    {
      id: "breast_cancer",
      name: "Breast Cancer",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_BREAST_CANCER,
    },
    {
      id: "inflammatory_breast_disorders",
      name: "Inflammatory Breast Disorders",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_INFLAMMATORY_BREAST_DISORDERS,
    },
    {
      id: "gynecomastia",
      name: "Gynecomastia",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_GYNECOMASTIA,
    },
    {
      id: "breast-cases",
      name: "Breast Cases",
      url: process.env.REACT_APP_STEP2_GYNECOLOGY_BREAST_CASES,
    },
  ],
  obstetrics: [
    {
      id: "pregnancy_care-normal_pregnancy",
      name: "Pregnancy Care: Normal Pregnancy",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_PREGNANCY_CARE_NORMAL_PREGNANCY,
    },
    {
      id: "pregnancy_care-prenatal_testing",
      name: "Pregnancy Care: Prenatal Testing",
      url: process.env.REACT_APP_STEP2_OBSTETRICS_PREGNANCY_CARE_ENATAL_TESTING,
    },
    {
      id: "pregnancy_care-multiple_gestation",
      name: "Pregnancy Care: Multiple Gestation",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_PREGNANCY_CARE_MULTIPLE_GESTATION,
    },
    {
      id: "maternal_complications-general_maternal_complications",
      name: "Maternal Complications: General Maternal Complications",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_MATERNAL_COMPLICATIONS_GENERAL_MATERNAL_COMPLICATIONS,
    },
    {
      id: "maternal_complications-hypertension_in_pregnancy",
      name: "Maternal Complications: Hypertension in Pregnancy",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_MATERNAL_COMPLICATIONS_HYPERTENSION_IN_PREGNANCY,
    },
    {
      id: "maternal_complications-diabetes_in_pregnancy",
      name: "Maternal Complications: Diabetes in Pregnancy",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_MATERNAL_COMPLICATIONS_DIABETES_IN_PREGNANCY,
    },
    {
      id: "maternal_complications-hepatobiliary_disorders_in_pregnancy",
      name: "Maternal Complications: Hepatobiliary Disorders in Pregnancy",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_MATERNAL_COMPLICATIONS_HEPATOBILIARY_DISORDERS_IN_PREGNANCY,
    },
    {
      id: "maternal_complications-maternal_infectious_disorders_in_pregnancy",
      name: "Maternal Complications: Maternal Infectious Disorders in Pregnancy",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_MATERNAL_COMPLICATIONS_MATERNAL_INFECTIOUS_DISORDERS_IN_PREGNANCY,
    },
    {
      id: "maternal_complications-placental_pathology",
      name: "Maternal Complications: Placental Pathology",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_MATERNAL_COMPLICATIONS_PLACENTAL_PATHOLOGY,
    },
    {
      id: "other_complications-teratogenesis_and_perinatal_infections",
      name: "Other Complications: Teratogenesis & Perinatal Infections",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_OTHER_COMPLICATIONS_TERATOGENESIS_AND_PERINATAL_INFECTIONS,
    },
    {
      id: "other_complications-antepartum_bleeding",
      name: "Other Complications: Antepartum Bleeding",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_OTHER_COMPLICATIONS_ANTEPARTUM_BLEEDING,
    },
    {
      id: "other_complications-fetal_complications",
      name: "Other Complications: Fetal Complications",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_OTHER_COMPLICATIONS_FETAL_COMPLICATIONS,
    },
    {
      id: "labor_and_delivery-normal_labor_and_delivery",
      name: "Labor & Delivery: Normal Labor and Delivery",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_LABOR_AND_DELIVERY_NORMAL_LABOR_AND_DELIVERY,
    },
    {
      id: "labor_and_delivery-operative_labor_and_delivery",
      name: "Labor & Delivery: Operative Labor and Delivery",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_LABOR_AND_DELIVERY_OPERATIVE_LABOR_AND_DELIVERY,
    },
    {
      id: "labor_and_delivery-pre_and_post_term_delivery",
      name: "Labor & Delivery: Pre and Post Term Delivery",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_LABOR_AND_DELIVERY_PRE_AND_POST_TERM_DELIVERY,
    },
    {
      id: "labor_and_delivery-failure_to_progress_and_difficult_labor",
      name: "Labor & Delivery: Failure to Progress and Difficult Labor",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_LABOR_AND_DELIVERY_FAILURE_TO_PROGRESS_AND_DIFFICULT_LABOR,
    },
    {
      id: "labor_and_delivery-complications_of_labor_and_delivery",
      name: "Labor & Delivery: Complications of Labor and Delivery",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_LABOR_AND_DELIVERY_COMPLICATIONS_OF_LABOR_AND_DELIVERY,
    },
    {
      id: "labor_and_delivery-postpartum_complications",
      name: "Labor & Delivery: Postpartum Complications",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_LABOR_AND_DELIVERY_POSTPARTUM_COMPLICATIONS,
    },
    {
      id: "labor_and_delivery-postpartum_care",
      name: "Labor & Delivery: Postpartum Care",
      url: process.env
        .REACT_APP_STEP2_OBSTETRICS_LABOR_AND_DELIVERY_POSTPARTUM_CARE,
    },
    {
      id: "obstetrics_cases",
      name: "Obstetrics Cases",
      url: process.env.REACT_APP_STEP2_OBSTETRICS_OBSTETRICS_CASES,
    },
  ],
  neonate_and_infant: [
    {
      id: "general_neonatalogy",
      name: "General Neonatology",
      url: process.env.REACT_APP_STEP2_NEONATE_AND_INFANT_GENERAL_NEONATALOGY,
    },
    {
      id: "neonatal_complications",
      name: "Neonatal Complications",
      url: process.env
        .REACT_APP_STEP2_NEONATE_AND_INFANT_NEONATAL_COMPLICATIONS,
    },
    {
      id: "neonatal_hyperbilirubinemia",
      name: "Neonatal Hyperbilirubinemia",
      url: process.env
        .REACT_APP_STEP2_NEONATE_AND_INFANT_NEONATAL_HYPERBILIRUBINEMIA,
    },
    {
      id: "infections",
      name: "Infections",
      url: process.env.REACT_APP_STEP2_NEONATE_AND_INFANT_INFECTIONS,
    },
    {
      id: "respiratory_distress",
      name: "Respiratory Distress",
      url: process.env.REACT_APP_STEP2_NEONATE_AND_INFANT_RESPIRATORY_DISTRESS,
    },
    {
      id: "hemorrhage",
      name: "Hemorrhage",
      url: process.env.REACT_APP_STEP2_NEONATE_AND_INFANT_HEMORRHAGE,
    },
    {
      id: "birth_trauma_and_msk_conditions",
      name: "Birth Trauma & MSK Conditions",
      url: process.env
        .REACT_APP_STEP2_NEONATE_AND_INFANT_BIRTH_TRAUMA_AND_MSK_CONDITIONS,
    },
    {
      id: "skin_conditions",
      name: "Skin Conditions",
      url: process.env.REACT_APP_STEP2_NEONATE_AND_INFANT_SKIN_CONDITIONS,
    },
    {
      id: "pediatric_development",
      name: "Pediatric Development",
      url: process.env.REACT_APP_STEP2_NEONATE_AND_INFANT_PEDIATRIC_DEVELOPMENT,
    },
    {
      id: "cases",
      name: "Neonate & Infant Cases",
      url: process.env.REACT_APP_STEP2_NEONATE_AND_INFANT_CASES,
    },
  ],
  genetics: [
    {
      id: "chromosomal_abnormalities",
      name: "Chromosomal Abnormalities",
      url: process.env.REACT_APP_STEP2_GENETICS_CHROMOSOMAL_ABNORMALITIES,
    },
    {
      id: "imprinting_disorders",
      name: "Imprinting Disorders",
      url: process.env.REACT_APP_STEP2_GENETICS_IMPRINTING_DISORDERS,
    },
    {
      id: "intellectual_disability_and_poor_development",
      name: "Intellectual Disability & Poor Development",
      url: process.env
        .REACT_APP_STEP2_GENETICS_INTELLECTUAL_DISABILITY_AND_POOR_DEVELOPMENT,
    },
    {
      id: "cystic_fibrosis_and_kartageners",
      name: "Cystic Fibrosis & Kartageners",
      url: process.env.REACT_APP_STEP2_GENETICS_CYSTIC_FIBROSIS_AND_KARTAGENERS,
    },
    {
      id: "collagen_disorders",
      name: "Collagen Disorders",
      url: process.env.REACT_APP_STEP2_GENETICS_COLLAGEN_DISORDERS,
    },
    {
      id: "marfanoid_habitus",
      name: "Marfanoid Habitus",
      url: process.env.REACT_APP_STEP2_GENETICS_MARFANOID_HABITUS,
    },
    {
      id: "myopathies_and_mitochondrial_disorders",
      name: "Myopathies & Mitochondrial Disorders",
      url: process.env
        .REACT_APP_STEP2_GENETICS_MYOPATHIES_AND_MITOCHONDRIAL_DISORDERS,
    },
    {
      id: "carbohydrate_intolerance_disorders",
      name: "Carbohydrate Intolerance Disorders",
      url: process.env
        .REACT_APP_STEP2_GENETICS_CARBOHYDRATE_INTOLERANCE_DISORDERS,
    },
    {
      id: "urea_cycle_disorders",
      name: "Urea Cycle Disorders",
      url: process.env.REACT_APP_STEP2_GENETICS_UREA_CYCLE_DISORDERS,
    },
    {
      id: "amino_acid_disorders",
      name: "Amino Acid Disorders",
      url: process.env.REACT_APP_STEP2_GENETICS_AMINO_ACID_DISORDERS,
    },
    {
      id: "other_errors_of_metabolism",
      name: "Other Errors of Metabolism",
      url: process.env.REACT_APP_STEP2_GENETICS_OTHER_ERRORS_OF_METABOLISM,
    },
    {
      id: "glycogen_storage_diseases",
      name: "Glycogen Storage Diseases",
      url: process.env.REACT_APP_STEP2_GENETICS_GLYCOGEN_STORAGE_DISEASES,
    },
    {
      id: "lipid_storage_diseases",
      name: "Lipid Storage Diseases",
      url: process.env.REACT_APP_STEP2_GENETICS_LIPID_STORAGE_DISEASES,
    },
    {
      id: "other_storage_diseases",
      name: "Other Storage Diseases",
      url: process.env.REACT_APP_STEP2_GENETICS_OTHER_STORAGE_DISEASES,
    },
    {
      id: "misc_genetic_diseases",
      name: "Misc Genetic Diseases",
      url: process.env.REACT_APP_STEP2_GENETICS_MISC_GENETIC_DISEASES,
    },
    {
      id: "cases",
      name: "Genetics Cases",
      url: process.env.REACT_APP_STEP2_GENETICS_CASES,
    },
  ],
  infectious_diseases: [
    {
      id: "gram_positive_bacteria",
      name: "Gram Positive Bacteria",
      url: process.env
        .REACT_APP_STEP2_INFECTIONS_DISEASES_GRAM_POSITIVE_BACTERIA,
    },
    {
      id: "gram_negative_atypical_bacteria",
      name: "Gram Negative & Atypical Bacteria",
      url: process.env
        .REACT_APP_STEP2_INFECTIONS_DISEASES_GRAM_NEGATIVE_ATYPICAL_BACTERIA,
    },
    // { id: 'zoonotic_tick_borne_bacteria', name: 'Zoonotic & Tick-Borne Bacteria', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_ZOONOTIC_TICK_BORNE_BACTERIA },
    {
      id: "mycobacteria",
      name: "Mycobacteria",
      url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_MYCOBACTERIA,
    },
    {
      id: "fungi",
      name: "Fungi",
      url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_FUNGI,
    },
    {
      id: "parasites",
      name: "Parasites",
      url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_PARASITES,
    },
    {
      id: "dna_viruses",
      name: "DNA Viruses",
      url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_DNA_VIRUSES,
    },
    {
      id: "rna_viruses",
      name: "RNA Viruses",
      url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_RNA_VIRUSES,
    },
    // { id: 'viral_hepatitis', name: 'Viral Hepatitis', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_VIRAL_HEPATITIS },
    {
      id: "hiv_aids",
      name: "HIV/AIDS",
      url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_HIV_AIDS,
    },
    // { id: 'prions', name: 'Prions', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_PRIONS },
    {
      id: "antimicrobials",
      name: "Antimicrobials",
      url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_ANTIMICROBIALS,
    },
    //{ id: 'misc_infections', name: 'Miscellaneous Infections', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_MISC_INFECTIONS },
    //{ id: 'pediatric_infections', name: 'Pediatric Infections', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_PEDIATRIC_INFECTIONS },
    //{ id: 'sexually_transmitted_infections', name: 'Sexually Transmitted Infections', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_SEXUALLY_TRANSMITTED_INFECTIONS },
    //{ id: 'healthcare_associated_infections', name: 'Healthcare Associated Infections', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_HEALTHCARE_ASSOCIATED_INFECTIONS },
    //{ id: 'infection_prophylaxis', name: 'Infection Prophylaxis', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_INFECTION_PROPHYLAXIS },
    //{ id: 'notifiable_disease', name: 'Notifiable Disease', url: process.env.REACT_APP_STEP2_INFECTIONS_DISEASES_NOTIFIABLE_DISEASE },
    {
      id: "infectious_disease_cases",
      name: "Infectious Disease Cases",
      url: process.env
        .REACT_APP_STEP2_INFECTIONS_DISEASES_INFECTIOUS_DISEASE_CASES,
    },
  ],
  surgery_and_anesthesia: [],
  emergency_and_toxicology: [
    {
      id: "burns_and_explosions",
      name: "Burns & Explosions",
      url: process.env
        .REACT_APP_STEP2_EMERGENCY_TRAUMA_AND_TOXICOLOGY_BURNS_AND_EXPLOSIONS,
    },
    {
      id: "toxicology_and_ingestion",
      name: "Toxicology & Ingestion",
      url: process.env
        .REACT_APP_STEP2_EMERGENCY_TRAUMA_AND_TOXICOLOGY_TOXICOLOGY_AND_INGESTION,
    },
    {
      id: "environmental_injury",
      name: "Environmental Injury",
      url: process.env
        .REACT_APP_STEP2_EMERGENCY_TRAUMA_AND_TOXICOLOGY_ENVIRONMENTAL_INJURY,
    },
    {
      id: "bites_and_stings",
      name: "Bites & Stings",
      url: process.env
        .REACT_APP_STEP2_EMERGENCY_TRAUMA_AND_TOXICOLOGY_BITES_AND_STINGS,
    },
    {
      id: "cases",
      name: "Emergency, Trauma & Toxicology Cases",
      url: process.env.REACT_APP_STEP2_EMERGENCY_TRAUMA_AND_TOXICOLOGY_CASES,
    },
  ],
  the_well_patient: [
    {
      id: "vaccinations",
      name: "Vaccinations",
      url: process.env.REACT_APP_STEP2_THE_WELL_PATIENT_VACCINATIONS,
    },
    {
      id: "screenings",
      name: "Screenings",
      url: process.env.REACT_APP_STEP2_THE_WELL_PATIENT_SCREENINGS,
    },
  ],
  biostatistics_and_epidemiology: [
    {
      id: "study_types",
      name: "Study Types",
      url: process.env
        .REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_STUDY_TYPES,
    },
    {
      id: "bias_and_study_errors",
      name: "Bias and Study Errors",
      url: process.env
        .REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_BIAS_AND_STUDY_ERRORS,
    },
    {
      id: "causality",
      name: "Causality",
      url: process.env.REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_CAUSALITY,
    },
    {
      id: "population_health",
      name: "Population Health & Demographics",
      url: process.env
        .REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_POPULATION_HEALTH,
    },
    {
      id: "statistics",
      name: "Statistics",
      url: process.env
        .REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_STATISTICS,
    },
    {
      id: "quantifying_risk",
      name: "Quantifying Risk",
      url: process.env
        .REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_QUANTIFYING_RISK,
    },
    {
      id: "diagnostic_tests",
      name: "Evaluation of Diagnostic Tests",
      url: process.env
        .REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_DIAGNOSTIC_TESTS,
    },
    {
      id: "data_visualization",
      name: "Data Visualization - Charts & Graphs",
      url: process.env
        .REACT_APP_STEP2_BIOSTATISTICS_AND_EPIDEMIOLOGY_DATA_VISUALIZATION,
    },
  ],

  // # Ethics and Communication
  ethics_and_communication: [
    {
      id: "general_ethics",
      name: "General Ethics",
      url: process.env.REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_GENERAL_ETHICS,
    },
    {
      id: "forensic_medicine",
      name: "Forensic Medicine",
      url: process.env
        .REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_FORENSIC_MEDICINE,
    },
    {
      id: "skills",
      name: "Communication Skills",
      url: process.env.REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_SKILLS,
    },
    {
      id: "special",
      name: "Special Situations",
      url: process.env.REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_SPECIAL,
    },
    {
      id: "cases",
      name: "Ethical Case Scenarios",
      url: process.env.REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_CASES,
    },
  ],

  // # Healthcare Delivery
  healthcare_delivery: [
    {
      id: "patient_care",
      name: "Patient Care",
      url: process.env.REACT_APP_STEP2_HEALTHCARE_DELIVERY_PATIENT_CARE,
    },
    {
      id: "end_of_life_care",
      name: "End of Life Care",
      url: process.env.REACT_APP_STEP2_HEALTHCARE_DELIVERY_END_OF_LIFE_CARE,
    },
    {
      id: "disease_prevention",
      name: "Disease Prevention",
      url: process.env.REACT_APP_STEP2_HEALTHCARE_DELIVERY_DISEASE_PREVENTION,
    },
    {
      id: "insurance",
      name: "Insurance",
      url: process.env.REACT_APP_STEP2_HEALTHCARE_DELIVERY_INSURANCE,
    },
  ],

  // # Quality and Safety
  quality_and_safety: [
    {
      id: "quality",
      name: "Quality",
      url: process.env.REACT_APP_STEP2_QUALITY_AND_SAFETY_QUALITY,
    },
    {
      id: "errors",
      name: "Errors",
      url: process.env.REACT_APP_STEP2_QUALITY_AND_SAFETY_ERRORS,
    },
    {
      id: "medical_error_analysis",
      name: "Medical Error Analysis",
      url: process.env
        .REACT_APP_STEP2_QUALITY_AND_SAFETY_MEDICAL_ERROR_ANALYSIS,
    },
    {
      id: "effective_teams",
      name: "Effective Teams",
      url: process.env.REACT_APP_STEP2_QUALITY_AND_SAFETY_EFFECTIVE_TEAMS,
    },
    {
      id: "fatigue_burnout_liability",
      name: "Fatigue, Burnout & Liability",
      url: process.env
        .REACT_APP_STEP2_QUALITY_AND_SAFETY_FATIGUE_BURNOUT_LIABILITY,
    },
  ],

  // # Pharmacology Review
  pharmacology_review: [],
};
